import './primitives.css';

function Kicker({ children, className = '' }) {
  return <div className={`kicker ${className}`.trim()}>{children}</div>;
}

export default Kicker;
